import api from "./client";

export const listSites = async () => {
  // backend returns all for admins, filtered to user_sites for others
  const { data } = await api.get("/sites/my");
  return data;
};

export const createSite = async (payload) => {
  const { data } = await api.post("/sites/", payload);
  return data;
};

// Implement if your backend supports it:
export const updateSite = async (id, payload) => {
  const { data } = await api.put(`/sites/${id}/`, payload);
  return data;
};

export const deleteSite = async (id) => {
  const { data } = await api.delete(`/sites/${id}/`);
  return data;
};

export const recalcSiteCapacity = async (id) => {
  const { data } = await api.post(`/sites/${id}/recalculate-capacity`);
  return data;
};

export const updateSiteAcquisitionMode = async (id, acquisitionMode) => {
  const { data } = await api.patch(`/sites/${id}/acquisition-mode`, {
    acquisition_mode: acquisitionMode,
  });
  return data;
};
